import { React, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Box, IconButton, useTheme } from "@mui/material";
import ArrowRightSharpIcon from "@mui/icons-material/ArrowRightSharp";
import ArrowLeftSharpIcon from "@mui/icons-material/ArrowLeftSharp";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";

import { hasAny, isEmptyObject, SessionStorage } from "../../util";
import { tokens } from "../../helper/theme";
import { SubNavContainer, Item } from "./";
import { getNavBar } from "../../api/commonApi";
import { CommonPages, Common, NavigationBar, SchoolAdmin, PupilProgress, RolesEnum, BigPicturePages } from "../../helper";
import { setClasses } from "../../store/classesSlice"
import { setSelect, setStyleProps } from "../../store/stylesSlice";

import MappixLogo from "../../assets/images/MappixLogo.png";
import HexagonCharacterNav from "../../assets/images/HexagonIconNavBar.png";
import DashboardLogo from "../../assets/images/DashboardLogo.svg"
import MyClassesLogo from "../../assets/images/MyClasses.svg"
import AdminLogo from "../../assets/images/Admin.svg"
import AccountSettingLogo from "../../assets/images/AccountSettings.svg"
import DashboardLogoSelected from "../../assets/images/space_dashboardDashboardSelected.svg"
import MyClassesLogoSelected from "../../assets/images/MyClassesSelected.svg"
import AdminLogoSelected from "../../assets/images/AdminSelected.svg"
import AccountSettingLogoSelected from "../../assets/images/VectorAccountsSettingSelected.svg"
import BigPictureIcon from "../../assets/images/BigPictureIcon.svg"
import BigPictureIconSelected from "../../assets/images/BigPictureSelected.svg"
// import { setPupilSavedReport } from "../../store/pupilProgressSlice";

const SideNavBar = () => {
  const user = useSelector((state) => state.login.user);
  const select = useSelector((state) => state.styleData.select)
  const isNavCollapsed = useSelector((state) => state.styleData.isNavCollapsed)
  const dispatch = useDispatch()
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useState(isNavCollapsed);
  const [myClasses, setMyClasses] = useState(select==="My Classes" || select==="Class Home");
  const [ClassArray, setClassArray] = useState([]);

  const getNavData = async () => {
    const _navigationbar = await getNavBar({});
    if (!isEmptyObject(_navigationbar)) {
      setClassArray(_navigationbar.Items);
    } else {
      dispatch(setClasses([]))
      setClassArray([]);
    }
  }

  const handleNavSelect = (key) => {
    SessionStorage.setItem(Common.EKey, key)
  };

  const handleMyClassClick = (boolean, title) => {
    if(isCollapsed){
      setIsCollapsed(false)
      dispatch(setStyleProps({ isNavCollapsed: false }))
    }else{
      setMyClasses(!boolean);
      dispatch(setSelect(title))
    }
  }
  const handleNavCollapse = () => {
    dispatch(setStyleProps({ isNavCollapsed: !isCollapsed }))
    setIsCollapsed(!isCollapsed);
    // !isCollapsed && setMyClasses(false);
  }
  // const handleItemClickToSetSavedReport = () => {
  //   console.log("Before dispatch");
  //   dispatch(setPupilSavedReport({}));
  //   console.log("After dispatch");
  // }

  useEffect(() => {
    if (hasAny(user.userType, [RolesEnum.Teacher]) || hasAny(user.userType, [RolesEnum.LeadTeacher])) {
      getNavData();
    }
    dispatch(setSelect("Dashboard"));
  }, [])

  useEffect(() => {
    if (select === "My Classes" || select==="Class Home") {
      setMyClasses(true);
    } else {
      setMyClasses(false);
    }
  }, [select]);
  

  return (
    <div style={{ height: "100%", position: "fixed", zIndex: "100" }}>
      <Box
        sx={{
          "& .pro-sidebar-inner": {
            background: `${colors.primary[400]} !important`
          },
          "& .pro-icon-wrapper": {
            backgroundColor: "transparent !important"
          },
          "& .pro-inner-item": {
            padding: "5px 35px 5px 20px !important"
          },
          "& .pro-inner-item:hover": {
            color: "#868dfb !important"
          },
          "& .pro-menu-item.active": {
            color: "#6870fa !important"
          }
        }}
      >
        <Sidebar className="app" collapsed={isCollapsed}>
          {hasAny(user.userType, [RolesEnum.MappixAdmin]) ? <Menu>
            <MenuItem onClick={() => handleNavCollapse()} icon={isCollapsed ? <img src={HexagonCharacterNav} alt="hexagon-character" style={{ width: "40px", height: "30px" }} /> : undefined}
              style={{
                margin: "10px 0 20px 0",
                color: colors.primary[500]
              }}
            >
              {!isCollapsed && (
                <Box display="flex" alignItems="center" ml="15px" >
                  <IconButton onClick={() => setIsCollapsed(!isCollapsed)} style={{ marginLeft: "-5px" }}>
                    <img src={HexagonCharacterNav} alt="hexagon-character" style={{ width: "40px", height: "30px" }} />
                  </IconButton>
                  <img src={MappixLogo} className="nav-logo" alt="Mappix" style={{ marginLeft: "20px",width:"101px",height:"47px" }} />
                </Box>
              )}
              {!isCollapsed ? <div className="image-text" ><span className="image"><ArrowLeftSharpIcon style={{ fill: "#fff" }} /></span></div> : <div className="image-text"><span className="image1"><ArrowRightSharpIcon style={{ fill: "#fff" }} /></span></div>}
            </MenuItem>
            <Box paddingLeft={isCollapsed ? "0% " : "10%"} >
              <Item title="Dashboard" to={`${NavigationBar.SuperAdmin}`} icon={<img src={select === "Dashboard" ? DashboardLogoSelected : DashboardLogo} alt="DashboardLogo" />} setMyClasses={setMyClasses} />
              <hr style={{ margin: "10px 20px 10px 20px" }} />
              <Item title="Account Settings" to={`/${NavigationBar.AccountSettings}`} icon={<img src={select === "Account Settings" ? AccountSettingLogoSelected : AccountSettingLogo} alt="AccountSettingLogo" />} setMyClasses={setMyClasses} />
              <hr style={{ margin: "10px 20px 10px 20px" }} />
            </Box>
          </Menu> : <Menu>
            <MenuItem onClick={() => handleNavCollapse()} icon={isCollapsed ? <img src={HexagonCharacterNav} alt="hexagon-character" style={{ width: "40px", height: "30px" }} /> : undefined}
              style={{
                margin: "10px 0 20px 0",
                color: colors.primary[500]
              }}
            >
              {!isCollapsed && (
                <Box display="flex" alignItems="center" ml="15px" >
                  <IconButton onClick={() => setIsCollapsed(!isCollapsed)} style={{ marginLeft: "-5px" }}>
                    <img src={HexagonCharacterNav} alt="hexagon-character" style={{ width: "40px", height: "30px" }} />
                  </IconButton>
                  <img src={MappixLogo} className="nav-logo" alt="Mappix" style={{ marginLeft: "20px",width:"101px",height:"47px" }} />
                </Box>
              )}
              {!isCollapsed ? <div className="image-text" ><span className="image"><ArrowLeftSharpIcon style={{ fill: "#fff" }} /></span></div> : <div className="image-text"><span className="image1"><ArrowRightSharpIcon style={{ fill: "#fff" }} /></span></div>}
            </MenuItem>
            <Box>
              <Item title="Dashboard" to={`${CommonPages.dashboard}`} icon={<img src={select === "Dashboard" ? DashboardLogoSelected : DashboardLogo} alt="DashboardLogo" />} setMyClasses={setMyClasses} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
              <hr style={{ margin: "10px 20px 10px 20px", color: "white" }} />
              {hasAny(user.userType, [RolesEnum.Teacher, RolesEnum.LeadTeacher]) ? <SubMenu label="My Classes" icon={<img src={myClasses === true ? MyClassesLogoSelected : MyClassesLogo} alt="MyClassesLogo" />} setMyClasses={setMyClasses} style={myClasses === true ? { color: "#FFA177" } : { color: "#FFF" }} onClick={() => handleMyClassClick(myClasses, "My Classes")} open={myClasses === true}>
                {myClasses === true ? <SubNavContainer ClassArray={ClassArray} setMyClasses={setMyClasses} handleNavSelect={handleNavSelect} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} /> : ""}
              </SubMenu> : null}
              {hasAny(user.userType, [RolesEnum.Teacher, RolesEnum.LeadTeacher]) ? <hr style={{ margin: "10px 20px 10px 20px", color: "white" }} /> : ""}
              {hasAny(user.userType, [RolesEnum.Teacher, RolesEnum.LeadTeacher, RolesEnum.Admin]) ? <Item title="Pupils" to={PupilProgress.pupilTable} icon={<PeopleOutlinedIcon />} setMyClasses={setMyClasses} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed}/> : null}
              {hasAny(user.userType, [RolesEnum.Teacher, RolesEnum.LeadTeacher, RolesEnum.Admin]) ? <hr style={{ margin: "10px 20px 10px 20px", color: "white" }} /> : ""}
              {/* <Item title="Big Picture" to={`/${NavigationBar.BigPicture}`} icon={<PeopleOutlinedIcon />} setMyClasses={setMyClasses} /> */}
              {hasAny(user.userType, [RolesEnum.LeadTeacher]) ? <Item title="Big Picture" to={BigPicturePages.landingPageBigPic} icon={<img src={select === "Big Picture" ? BigPictureIconSelected : BigPictureIcon} alt="BP_landing" />} setMyClasses={setMyClasses} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed}/> : null}
              {hasAny(user.userType, [RolesEnum.LeadTeacher]) ? <hr style={{ margin: "10px 20px 10px 20px", color: "white" }} /> : ""}
              {hasAny(user.userType, [RolesEnum.LeadTeacher, RolesEnum.Admin]) ? <Item title="Admin" to={SchoolAdmin.schoolAdmin} icon={<img src={select === "Admin" ? AdminLogoSelected : AdminLogo} alt="AdminLogo" />} setMyClasses={setMyClasses} onClick={() => { sessionStorage.setItem("TabIndex", 0) }} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed}/> : null}
              {hasAny(user.userType, [RolesEnum.LeadTeacher, RolesEnum.Admin]) ? <hr style={{ margin: "10px 20px 10px 20px", color: "white" }} /> : ""}
              <Item title="Account Settings" to={`/${NavigationBar.AccountSettings}`} icon={<img src={select === "Account Settings" ? AccountSettingLogoSelected : AccountSettingLogo} alt="AccountSettingLogo" />} setMyClasses={setMyClasses} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
              <hr style={{ margin: "10px 20px 10px 20px", color: "white" }} />
            </Box>
          </Menu>}
        </Sidebar>
      </Box>
    </div>
  );
};

export { SideNavBar };
